// extracted by mini-css-extract-plugin
export var company = "styles-module--company--90449";
export var companyName = "styles-module--companyName--d0ec1";
export var logo = "styles-module--logo--355b2";
export var logoLink = "styles-module--logoLink--2ce5d";